import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IWarningDialogProps {
    dialogName: string;
    handleConfirm?: () => void;
    handleCancellation?: () => void;
    hideDialog: () => void;
    label?: string;
    message?: string;
    heading?: string;
    confirmLabel?: string;
}

const WarningDialog = (props: IWarningDialogProps) => {

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('WarningDialog onCreate()');
    };

    const handleSelection = () => {
        props.handleConfirm?.();
        props.hideDialog();
    };

    const handleCancelButton = () => {
        if (props?.handleCancellation) {
            props.handleCancellation();
        }
        props.hideDialog();
    };

    return (
        <Dialog title={props?.heading ? props?.heading : 'Warning'} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    ⚠️
                    <label>{!!props?.label ? props?.label : `Are you sure you want to delete this record?`}</label>
                    <br />
                    <label> {props?.message ? props?.message : 'Click OK to delete, Cancel to go back.'} </label>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={props?.confirmLabel ? props.confirmLabel : 'OK'}
                    onClick={() => handleSelection()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => handleCancelButton()}
                />
            </div>
        </Dialog>
    );
};

export default WarningDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/dialogs/WarningDialog.tsx